import React from "react";
import PropTypes from "prop-types";
import { Container } from "semantic-ui-react";
import { SearchBarILS } from "@components/SearchBar";
import { NotFound } from "@components/HttpErrors";
import { invenioConfig } from "@config";
import Overridable from "react-overridable";
import { goTo } from "@history";
import { FrontSiteRoutes } from "@routes/urls";
import _get from "lodash/get";
import SpecialCollectionDetailsLayout from "./SpecialCollectionDetailsLayout";

class SpecialCollectionDetails extends React.Component {
  componentDidMount() {
    const {
      match: {
        params: { specialCollectionPid },
      },
    } = this.props;

    this.props.fetchSpecialCollectionDetails(specialCollectionPid);
  }

  componentDidUpdate(prevProps) {
    const {
      match: {
        params: { specialCollectionPid },
      },
    } = this.props;
    if (prevProps.match.params.specialCollectionPid !== specialCollectionPid) {
      this.props.fetchSpecialCollectionDetails(specialCollectionPid);
    }
  }

  onSearchClick = (searchQuery) => {
    const query = encodeURIComponent(searchQuery);
    goTo(FrontSiteRoutes.documentsListWithQuery(query));
  };

  render() {
    const { hasError, error, isLoading, specialCollection } = this.props;

    if (hasError && _get(error, "response.status") === 404) {
      return <NotFound />;
    }

    return (
      <>
        <Container fluid className="literature-search-container">
          <Overridable
            id="SpecialCollectionDetails.top"
            executeSearch={this.onSearchClick}
          >
            <Container>
              <SearchBarILS
                onPasteHandler={() => {}}
                onSearchHandler={this.onSearchClick}
                placeholder={invenioConfig.APP.HOME_SEARCH_BAR_PLACEHOLDER}
                className="fs-headline"
              />
            </Container>
          </Overridable>
        </Container>

        <SpecialCollectionDetailsLayout
          isLoading={isLoading}
          error={error}
          specialCollection={specialCollection}
        />
      </>
    );
  }
}

SpecialCollectionDetails.propTypes = {
  /* redux */
  specialCollection: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  fetchSpecialCollectionDetails: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  error: PropTypes.object,
  match: PropTypes.shape({
    params: PropTypes.shape({
      specialCollectionPid: PropTypes.string,
    }),
  }).isRequired,
};

SpecialCollectionDetails.defaultProps = {
  error: null,
};

export default Overridable.component(
  "SpecialCollectionDetails",
  SpecialCollectionDetails
);
